import { useQuery } from 'react-query';
import { useLocalStorage } from 'usehooks-ts';

import { CONFIG_STALE_TIME } from 'coreOld/constants';
import { LocalStorageKeys } from 'coreOld/enums';
import { defaultColors } from 'coreOld/components/Theme/configs';
import { themesService } from 'coreOld/services';
import { getColorsTheme, getFontsTheme } from 'coreOld/utils';

// TODO when company settings is implemented, invalidate this query on colors update
export const useGetColorsTheme = () => {
  const [colors, setColors] = useLocalStorage(LocalStorageKeys.COLORS_THEME, defaultColors);

  const { isError, isLoading } = useQuery(
    ['colorsTheme'],
    ({ signal }) => themesService.getColorsTheme(signal),
    {
      keepPreviousData: true,
      staleTime: CONFIG_STALE_TIME,
      onSuccess: (data) => {
        setColors(getColorsTheme(data, 'color_'));
      },
    }
  );

  return {
    colorsTheme: colors,
    colorsThemeError: isError,
    colorsThemeLoading: isLoading,
  };
};

// TODO when company settings is implemented, invalidate this query on fonts update
export const useGetFontsTheme = () => {
  const [fonts, setFonts] = useLocalStorage(LocalStorageKeys.FONTS_THEME, {});

  const { isError, isLoading } = useQuery(
    ['fontsTheme'],
    ({ signal }) => themesService.getFontsTheme(signal),
    {
      keepPreviousData: true,
      staleTime: CONFIG_STALE_TIME,
      onSuccess: (data) => {
        setFonts(getFontsTheme(data, 'font_'));
      },
    }
  );

  return {
    fontsTheme: fonts,
    fontsThemeError: isError,
    fontsThemeLoading: isLoading,
  };
};

export const useGetFontFamiliesTheme = () => {
  const [fontFamilies, setFontFamilies] = useLocalStorage(LocalStorageKeys.FONT_FAMILIES_THEME, []);

  const { isError, isLoading } = useQuery(
    ['fontFamiliesTheme'],
    ({ signal }) => themesService.getFontFamiliesTheme(signal),
    {
      keepPreviousData: true,
      staleTime: CONFIG_STALE_TIME,
      onSuccess: (data) => {
        setFontFamilies(data);
      },
    }
  );

  return {
    fontFamiliesTheme: fontFamilies,
    fontFamiliesThemeError: isError,
    fontFamiliesThemeLoading: isLoading,
  };
};
